
export default {
  name: 'AppHeader',
  props: {
  }
}
